import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface RoleBasedRouteProps {
  children: React.ReactNode;
  permission: string;
  fallback?: React.ReactNode;
}

export function RoleBasedRoute({
  children,
  permission,
  fallback,
}: RoleBasedRouteProps) {
  const { hasPermission, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-green-700" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasPermission(permission)) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <Navigate
        to="/dashboard"
        state={{
          error: "Você não tem permissão para acessar esta página",
        }}
        replace
      />
    );
  }

  return <>{children}</>;
}
